export const countryCode = {
  us: "us",
  in: "IND",
};
